/* eslint-disable react-hooks/exhaustive-deps */
import { RewardReviewItem } from 'components/reward-review-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Box from 'components/ui/box';
import { useEffect, useMemo, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { getKPIHistory, getKPIPublicHistoryByTime, getPlayerInfo } from 'services/dashboard.service';
import { getPublicProfile } from 'services/profile.service';
import Avatar from 'funifier-nice-avatar';
import { GetBehaviorLabel } from 'utils/strings';
import { Selo } from 'components/icons';
import Humanograma from 'components/Humanograma';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import { useModal } from 'context/ModalContext';
import { getLevelTitle } from 'services/utils';
import { isGrupoValido } from 'utils/helpers';

// const behaviors: any = {
//   colaboracao: <SeloColaboracao size={'100%'} />,
//   inovacao: <SeloInovacao size={'100%'} />,
//   foco: <SeloFocoNoCliente size={'100%'} />,
//   resolutividade: <SeloResolutividade size={'100%'} />,
// };

interface DestaquesCulturaDetailProps {
  id?: string;
  active: any;
  behavior?: string;
  grupo?: string;
  funcis?: number;
  onClose: () => void;
}
export function DestaquesCulturaDetail({ id, active, behavior, grupo, funcis, onClose }: DestaquesCulturaDetailProps) {
  const behaviors: any = useMemo(() => {
    return {
      colaboracao: <Selo size={'100%'} cycle={active.label} selo="Colaboracao" />,
      foco: <Selo size={'100%'} cycle={active.label} selo="Foco" />,
      inovacao: <Selo size={'100%'} cycle={active.label} selo="Inovacao" />,
      resolutividade: <Selo size={'100%'} cycle={active.label} selo="Resolutividade" />,
      lideranca: <Selo size={'100%'} cycle={active.label} selo="Lideranca" />,
    };
  }, [active]);

  const [user, setUser] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();

  const [list, setList] = useState<unknown[]>();

  // const [loading, setLoading] = useState();
  const [loadingList, setLoadingList] = useState(true);

  const { showModal } = useModal();

  useEffect(() => {
    if (!id) {
      onClose();
      return;
    }

    async function loadPlayerInfo() {
      if (!id) return;

      const userProfile = await getPublicProfile(id, active._id);
      const playerInfo = await getPlayerInfo(id);
      setUserInfo(playerInfo);
      setUser(userProfile);

      // const isGestor = playerInfo.tipo_ro === 'GERENCIAL' || playerInfo.funcao === 'DIRETOR';

      // if (isGestor) {
      //   const dataGestor = await getMissaoGestor(id);
      //   const dataEquipe = await getMissaoEquipe(id);
      //   setMissionList([...dataGestor, ...dataEquipe]);
      // } else {
      //   const data = await getMissaoEquipe(id);
      //   setMissionList(data);
      // }

      // setLoadingMissionList(false);

      loadReconhecimentos();
    }

    async function loadReconhecimentos() {
      const result = await getKPIPublicHistoryByTime(id, active.date_start, active.date_end, active._id);
      const filteredData = result
        .filter((x: any) => !x.cancelled)
        .filter((item: any) => {
          return item.behavior === behavior;
        });
      setList(filteredData);
      setLoadingList(false);
    }

    loadPlayerInfo();
    // loadReconhecimentos();

    window.scrollTo(0, 0);
  }, [id, behavior]);

  return (
    <div className="mx-auto container p-3 lg:p-10">
      <div className="flex flex-row items-center space-x-3 lg:space-x-2 mb-3 lg:mb-10">
        <button
          onClick={() => onClose()}
          className="rounded-full bg-purple flex justify-center items-center p-1"
          aria-label="Voltar para destaques da cultura"
        >
          <RiArrowLeftSLine size={28} className="text-white" aria-hidden="true" />
        </button>
        <h1 className="text-lg lg:text-3xl py-1 px-6">
          {behavior ? <span>{GetBehaviorLabel(behavior)}</span> : <span>Destaques da Cultura BB</span>}
        </h1>
      </div>

      {userInfo && (
        <div className="bg-oxford-blue rounded-3xl p-10 mb-10 flex flex-col lg:flex-row space-y-3 justify-between">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-3 text-center lg:text-left">
            <div className="w-28 h-28 md:w-44 md:h-44 bg-purple flex items-center justify-center rounded-full overflow-hidden text-3xl md:text-6xl">
              {!!user.extra.avatar_type &&
                (user.image ? <img src={user.image.medium.url} alt={user.name} className="w-full h-full" /> : user.name[0])}
              {!user.extra.avatar_type &&
                (!!user.extra.avatar ? <Avatar className="w-full h-full" {...user.extra.avatar} /> : user.name[0])}
            </div>
            <div className="space-y-3">
              <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
                <div className="text-lg md:text-2xl text-white font-bold">
                  {user?.name} <span className="font-thin">({user?._id})</span>
                </div>
              </Humanograma>
              {/* <p className='text-xl font-thin'>Nível: <b className='text-electric-blue font-bold'>Conectado</b></p> */}
              {userInfo && (
                <div className="md:text-xl font-thin">
                  {user?.level && !!isGrupoValido(user?.grupo) && (
                    <div className="mb-4 flex items-center">
                      <span>
                        Nível: <b className="text-electric-blue">{getLevelTitle(user?.level)}</b>{' '}
                      </span>
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>Nível definido.</>}
                      >
                        <span className="ml-2" aria-label="Nível definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                    </div>
                  )}

                  {user?.grupo ? (
                    <button
                      className="flex items-center space-x-2 text-left"
                      onClick={() => showModal('group-detail-extrato')}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          showModal('group-detail-extrato');
                        }
                      }}
                      aria-label={`Ver detalhes do grupo ${user?.grupo}, ${user?.grupo_total || userInfo?.grupo?.total} funcionários`}
                    >
                      <span>{user?.grupo ? user.grupo : userInfo?.grupo?.nome}</span>{' '}
                      <span>({user?.grupo_total ? user?.grupo_total : userInfo?.grupo?.total} funci) </span>{' '}
                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={<>O seu grupo de classificação está definido.</>}
                      >
                        <span className="ml-2" aria-label="O seu grupo de classificação está definido">
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </span>
                      </Tippy>
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </button>
                  ) : (
                    <div className="md:text-xl font-thin">
                      <span>{userInfo?.grupo?.nome}</span> <span>({userInfo?.grupo?.total} funci)</span>{' '}
                      <span className="font-bold text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue">
                        {userInfo?.ro}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {behavior && (
            <div className="flex flex-col justify-center items-center space-y-4">
              <div className="w-[114px]">{behaviors[behavior]}</div>
              <b className="text-xl text-yellow">Selo conquistado</b>
            </div>
          )}
        </div>
      )}

      <div className="w-full flex flex-col space-y-5">
        {/* <Box>
          <div className="space-y-5 lg:p-3">
            <h3 className="text-2xl mb-3">
              Realização
              <br />
              <span className="text-xl lg:text-3xl font-bold text-yellow ">Destaque</span>
            </h3>

            {loadingMissionList ? (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            ) : null}

            {!loadingMissionList ? (
              <div className="space-y-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {missionList?.map((item: any) => (
                    <PointReviewItem data={item} key={item._id} />
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </Box> */}

        <h2 className="text-2xl mb-3">Confira abaixo os reconhecimentos realizados nesta modalidade:</h2>

        <Box>
          <section className="space-y-5 lg:p-3" aria-labelledby="reconhecimentos-cultura-heading">
            <h3 id="reconhecimentos-cultura-heading" className="text-2xl mb-3">Reconhecimentos recebidos {list ? `(${list?.length})` : null}</h3>

            {loadingList ? (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            ) : null}

            {!loadingList ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {list?.map((item: any) => <RewardReviewItem data={item} key={item._id} />)}
              </div>
            ) : null}
          </section>
        </Box>
      </div>
      {user?._id && user?.grupo && <GroupDetailModalExtrato player={user?._id} cycleLabel={active?.label} />}
    </div>
  );
}
